//@helpers
const { formatText } = require('core/i18n').i18n;

const getDocumentName = (poeditorPrefix, key) => {
    return __CONTACT_CENTER__
        ? formatText(`${poeditorPrefix}-${poeditorPrefix}_${key}`)
        : formatText(`${poeditorPrefix}-${key}`);
}

const addAcceptedText = () => {
    const poeditorPrefix = __CONTACT_CENTER__ ? 'insuranceRequestHomeCC' : 'insuranceRequestHome';
    const conditionsText = __CONTACT_CENTER__ ? 'step5Conditions' : 'insuranceConditionsLabelWeb'

    const step5LinkBudget = getDocumentName(poeditorPrefix, 'step5LinkBudget');
    const step5LinkProductInformation = getDocumentName(poeditorPrefix, 'step5LinkProductInformation');
    const step5LinkDocumentConditions = getDocumentName(poeditorPrefix, 'step5LinkDocumentConditions');
    const step5LinkMediator = getDocumentName(poeditorPrefix, 'step5LinkMediator');
    let documentsNames = [step5LinkBudget, step5LinkProductInformation, step5LinkDocumentConditions, step5LinkMediator];

    if (__CONTACT_CENTER__) {
        documentsNames = [step5LinkMediator, step5LinkBudget, step5LinkProductInformation, step5LinkDocumentConditions];
    }
    return formatText(`${poeditorPrefix}-${poeditorPrefix}_${conditionsText}`, documentsNames);
}

module.exports = {
    addAcceptedText
}